export default "__VITE_ASSET__C9U_Yr8c__"